export enum ERROR_LOG_TYPE {
  FRONTEND_ERROR = 'FRONTEND_ERROR'
}

export enum ERROR_LOG_SUBTYPE {
  UI = 'UI',
  API = 'API',
}

// Discriminates a 403 the API refuses on data-provenance grounds from a plain permission denial,
// which returns the same status with no code.
export enum APP_ERROR_CODE {
  SALESFORCE_MANAGED_BROKER = 'SALESFORCE_MANAGED_BROKER',
}

export enum USER_STATUS {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum CONTACT_TYPE {
  INDIVIDUAL = 'Individual',
  BUSINESS = 'Business',
}

export enum USER_CONTACT_ROLE {
  PERSONAL = 'Personal',
  BUSINESS = 'Business',
  ASSISTANT = 'Assistant',
  OTHER = 'Other'
}

export enum JETCARD_STATUS {
  DRAFT = 'Draft',
  PAYMENT_DUE = 'Payment Due',
  SENT = 'Sent',
  REJECTED = 'Rejected',
  LIVE = 'Live',
  EXHAUSTED = 'Exhausted',
  INACTIVE = 'Inactive',
  AWAITING_APPROVAL = 'Awaiting Approval'
}

export enum JETCARD_TYPE_KEY {
  ALL_IN = 'All In',
  ALL_ACCESS = 'All Access',
  FLIGHT_FUNDS = 'Flight Funds',
  FLIGHT_HOURS = 'Flight Hours',
}

export enum JETCARD_TYPE_ID {
  STANDARD = 1,
  ALL_IN = 2,
  ALL_ACCESS = 3,
}

export enum AIRCRAFT_TYPE_KEY {
  LIGHT = 'Light',
  MID = 'Mid',
  SUPER_MID = 'Super Mid',
  HEAVY = 'Heavy',
  PISTON = 'Piston',
  VLJ = 'VLJ',
  TURBO_PROP = 'Turbo Prop',
  OTHER = 'Other',
}

export enum TRIP_TYPE_KEY {
  CHARTER = 'CHARTER',
  JET_CARD = 'JET_CARD',
}

export enum TRIP_STATUS_KEY {
  QUOTE_OPEN = 1,
  QUOTE_TO_BROKER,
  SENT_TO_CLIENT,
  ACCEPTED,
  ASSIGNMENT_MADE,
  UNKNOWN1,
  COMPLETED,
  FINALIZED,
  CANCELLED,
  CANCELLED_WITH_COST,
  CANCELLED_AND_FINALIZED,
  JET_CARD_PENDING,
  BROKER_TO_REVIEW,
  DRAFT,
  PARTIALLY_ASSIGNED,
  BROKER_TO_REVIEW2,
  QUOTE_TO_BROKER_PROPOSAL,
  QUOTE_TO_BROKER_SENT,
  JET_CARD_PENDING_PROPOSAL,
  JET_CARD_PENDING_SENT,
  ONGOING_TRIP
}

export enum TRIP_CREATION_SOURCE {
  COPILOT = 'COPILOT',
  MAVERICK = 'MAVERICK',
}

/**
 * Channel a Jet Card agreement was signed through, from `jet_card_agreements.signed_source`.
 * Absent on cards signed before the column shipped - there was no backfill, so a missing value
 * means the channel is unknown, not that it was web.
 */
export enum JETCARD_SIGNED_SOURCE {
  COPILOT = 'COPILOT',
  WEB = 'WEB',
}

export enum TRIP_LEG_STATUS_KEY {
  IN_QUEUE,
  QUOTE_REVIEW,
  CLIENT_REVIEW,
  ACCEPTED,
  SCHEDULER_ASSIGNED,
  DRAFT,
  ONGOING_TRIP,
  IN_TRANSIT,
  COMPLETED
}

export enum TRIP_ACTION_TYPE {
  CREATE_EDIT = 'CREATE_EDIT',
  MANAGE = 'MANAGE',
  OTHER = 'OTHER',
  INVALID = 'INVALID'
}

export enum DOCUMENT_TYPES {
  PASSPORT = 'Passport'
}

export enum EXCEL_CELL_FORMAT_TYPE {
  CURRENCY = '$#,##0.00',
  PERCENTAGE = '#,##0.00%'
}

export enum IS_TRIP_CANCELLED {
  NO,
  CANCELLED_WITH_COST,
  CANCELLED_WITHOUT_COST
}

export enum TASKS_PRIORITY {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export enum TASK_STATUS {
  COMPLETED = 'Completed',
  LATE_COMPLETED = 'LateCompleted',
  UPCOMING = 'Upcoming',
  OVERDUE = 'Overdue'
}

/** Task tag keys. Keys are stable across environments; the numeric ids are not. */
export enum TASK_TAG_KEY {
  NEW_BOOKINGS = 'NEW_BOOKINGS',
  HRS_48_PLUS = 'HRS_48_PLUS',
  HRS_24 = 'HRS_24',
  TRACKING = 'TRACKING',
  QA = 'QA',
  PENDING = 'PENDING',
  NOTIFY = 'NOTIFY',
}

export enum TASK_TIMING_TYPE {
  TRIGGERED = 'TRIGGERED',
  DEADLINE = 'DEADLINE',
}
